module.exports = __webpack_public_path__ + "static/media/toolbar-move.e227ca2c.svg";